import React from 'react';
import { AccountsMappingListing } from './AccountMappingListing';
import { BankAccountDetail } from './BankAccount/BankAccountDetail';
import { BankAccountForm } from './BankAccount/BankAccountForm';
import { BankAccountList } from './BankAccount/BankAccountList';
import { OutletGLInterface } from './OutletGLInterface/OutletGLInterface';
import { TaxMapping } from './TaxMapping/TaxMapping';
import { StatisticMapping } from './Statistic/StatisticMapping';
import { BankTTList } from './BankTT/PaymentCodeList';
import { PaymentCodeDetail } from './BankTT/PaymentCodeDetail';
import { PaymentCodeForm } from './BankTT/PaymentCodeForm';

const accountMappingRoutes = [
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping`,
		},
		component: <AccountsMappingListing />,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/bank-account`,
		},
		component: <BankAccountList />,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/bank-tt`,
		},
		component: <BankTTList mode="Bank TT" />,
	},
	{
    props: {
      exact: true,
      path: '/menu/outlet-app/account-journals/account-mapping/voucher',
    },
    component: <BankTTList mode="Voucher" />,
  },
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/outlet-gl-interface`,
		},
		component: <OutletGLInterface />,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/tax`,
		},
		component: <TaxMapping />,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/statistic`,
		},
		component: <StatisticMapping />,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/bank-account/:bankAccountID/detail`,
		},
		component: <BankAccountDetail />,
	},
		{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/bank-tt/detail`,
		},
		component: <PaymentCodeDetail  mode="Bank TT"/>,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/voucher/detail`,
		},
		component: <PaymentCodeDetail  mode="Voucher"/>,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/bank-tt/add`,
		},
		component: <PaymentCodeForm FormMode="add"  mode="Bank TT"/>,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/voucher/add`,
		},
		component: <PaymentCodeForm FormMode="add"  mode="Voucher"/>,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/bank-tt/edit`,
		},
		component: <PaymentCodeForm FormMode="edit"  mode="Bank TT"/>,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/voucher/edit`,
		},
		component: <PaymentCodeForm FormMode="edit"  mode="Voucher"/>,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/bank-account/add`,
		},
		component: <BankAccountForm mode="add" />,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/account-journals/account-mapping/bank-account/:bankAccountID/edit`,
		},
		component: <BankAccountForm mode="edit" />,
	},
];

export default accountMappingRoutes;
